import React, { Component } from 'react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import ReactHighcharts from 'react-highcharts'
import T from 'i18n-react'
import { CHART_HEIGHT, LINE_COLOR, LINE_COLOR_2, REFERENCE_LINE_COLOR, REFERENCE_LINE_WIDTH } from './constants'
import { getTranslationKey } from 'containers/Greenlight/utils'
require('highcharts-data')(ReactHighcharts.Highcharts)

class DataChart extends Component {

    constructor(props){
        super(props)
        const {
            data
        } = props
        this.points = []
        if(data.length > 0){
            this.points = data[0].points.map(function(pointArr) {
                return pointArr.slice()
            })
        }
        for(var i = 1; i < data.length; i++){
            for(var j = 0; j < data[i].points.length; j++){
                this.points[j].push(data[i].points[j][1])
            }
        }
        this.labels = [T.translate(`testReport.chart.xAxisLabel`)]
        for(var i = 0; i < data.length; i++){
            this.labels.push('GPU ' + (i+1))
        }
    }

    shouldComponentUpdate(){
        return false
    }

    render(){
        const translationKey = getTranslationKey(this.props.name)
        const name = T.translate(`testReport.dataTableValues.${translationKey}.name`)
        const unit = T.translate(`testReport.dataTableValues.${translationKey}.unit`)

        return(
            <div styleName='chartContainer'>
                <ReactHighcharts ref='chart' config={{
                    chart: {
                        type: 'line',
                        height: CHART_HEIGHT,
                        zoomType: 'x'
                    },
                    title: {
                        text: name
                    },
                    colors: [LINE_COLOR, LINE_COLOR_2],
                    data: {
                        rows: [
                            this.labels,
                            ...this.points
                        ]
                    },
                    plotOptions: {
                        line: {
                            animation: false,
                            lineWidth: 2,
                            marker: {
                                radius: 2
                            },
                            states: {
                                hover: {
                                    lineWidth: 2
                                }
                            }
                        }
                    },
                    yAxis: {
                        tickAmount: 8,
                        title: {
                            text: unit
                        },
                        plotLines: [
                            /*{
                                value: data.min,
                                dashStyle: 'Dash',
                                color: REFERENCE_LINE_COLOR,
                                width: REFERENCE_LINE_WIDTH,
                                label: {
                                    text: T.translate(`testReport.chart.referenceLine.min`)
                                },
                                zIndex: 5
                            },
                            {
                                value: data.max,
                                dashStyle: 'Dash',
                                color: REFERENCE_LINE_COLOR,
                                width: REFERENCE_LINE_WIDTH,
                                label: {
                                    text: T.translate(`testReport.chart.referenceLine.max`)
                                },
                                zIndex: 5
                            },
                            {
                                value: data.avg,
                                dashStyle: 'Dash',
                                color: REFERENCE_LINE_COLOR,
                                width: REFERENCE_LINE_WIDTH,
                                label: {
                                    text: T.translate(`testReport.chart.referenceLine.avg`)
                                },
                                zIndex: 5
                            }*/
                        ]
                    },
                    xAxis: {
                        title: {
                            text: T.translate(`testReport.chart.xAxisLabel`)
                        },
                        type: 'datetime',
                        dateTimeLabelFormats : {
                            day: '%H:%M:%S',
                            hour: '%H:%M:%S',
                            minute: '%H:%M:%S',
                            second: '%H:%M:%S',
                            millisecond: '%H:%M:%S'
                        }
                    },
                    legend: {
                        enabled: (this.props.data.length > 1)
                    },
                    tooltip: {
                        xDateFormat: '%H:%M:%S',
                        valueSuffix: ' ' + unit
                    },
                    credits: {
                        enabled: false
                    }
                }}>
                </ReactHighcharts>
            </div>
        )

    }
}

export default CSSModules(styles)(DataChart)
